// src/screens/mypage/InviteFriendScreen.js
// 80차 계속: 신규 — 친구 초대 리워드. 별도 초대코드 발급 인프라 없이 본인 uid를 그대로
// 코드로 사용(공유는 네이티브 Share 시트로 텍스트 전달) — 새 가입 화면(RegisterScreen.js/
// SocialOnboardingScreen.js)의 "초대코드(선택)" 입력란에 이 코드를 붙여넣으면 가입 시
// applyReferralCF가 서버에서 검증 후 양쪽에 포인트를 지급한다(crewService.js와 동일하게
// 서버가 최종 검증하는 구조 — 이 화면은 그 코드를 "보여주고 공유"하는 역할만 함).
import React from 'react';
import { View, Text, TouchableOpacity, TextInput, StyleSheet, Share } from 'react-native';
import { useAuth } from '../../contexts/AuthContext';
import AppHeader from '../../components/common/AppHeader';
import GradientButton from '../../components/common/GradientButton';
import { PeopleIcon, ShareIcon, RewardIcon, IconLabel } from '../../components/common/Icons';
import { COLORS } from '../../constants/theme';

const GOLD = COLORS.gold, BG = COLORS.bg, SURFACE = COLORS.surface, SURFACE2 = COLORS.surface2;
const BORDER = COLORS.border, TEXT = COLORS.text, TEXT_SEC = COLORS.textSec, TEXT_MUTED = COLORS.textMuted;

export default function InviteFriendScreen({ navigation }) {
  const { user } = useAuth();
  const code = user?.uid || '';

  const handleShare = async () => {
    try {
      await Share.share({
        message: `UNLOCK에서 같이 방탈출 다녀요! 이 초대코드로 가입하면 포인트를 받을 수 있어요.\n\n초대코드: ${code}\n\nhttps://unlockapp.co.kr/`,
      });
    } catch {}
  };

  return (
    <View style={s.container}>
      <AppHeader showBack centerElement={<Text style={{ color: TEXT, fontSize: 15, fontWeight: '800' }}>친구 초대</Text>} />
      <View style={s.body}>
        <View style={s.iconWrap}><PeopleIcon size={40} /></View>
        <Text style={s.title}>친구를 초대하고{'\n'}둘 다 포인트 받아가세요</Text>
        <View style={s.rewardRow}>
          <View style={s.rewardCard}>
            <IconLabel Icon={RewardIcon} size={13} color={GOLD} textStyle={s.rewardLabel}>친구가 가입하면</IconLabel>
            <Text style={s.rewardValue}>+200P</Text>
          </View>
          <View style={s.rewardCard}>
            <IconLabel Icon={RewardIcon} size={13} color={GOLD} textStyle={s.rewardLabel}>친구는 가입 시</IconLabel>
            <Text style={s.rewardValue}>+100P</Text>
          </View>
        </View>

        <Text style={s.codeLabel}>내 초대코드</Text>
        {/* 80차 계속: [버그 수정] 새 클립보드 라이브러리 없이 TextInput 롱프레스로 복사하는
            관례(78차 이전부터, SuperAdminStoresScreen.js에도 동일 패턴) — editable={false}가
            Android에서 길게눌러 선택/복사하는 컨텍스트 메뉴 자체를 막아 실기기에서 복사가
            안 됐음(실사용자 실기기 테스트로 발견). editable은 기본값(true)대로 두고
            showSoftInputOnFocus={false}(키보드만 안 뜨게)+onChangeText 무시로 대체. */}
        <TextInput
          style={s.codeInput}
          value={code}
          showSoftInputOnFocus={false}
          onChangeText={() => {}}
          selectTextOnFocus
        />
        <Text style={s.codeHint}>길게 눌러 복사하거나, 아래 버튼으로 바로 공유하세요.</Text>

        <GradientButton label="공유하기" onPress={handleShare} style={{ marginTop: 20, paddingHorizontal: 24 }} />

        <Text style={s.note}>* 초대코드는 신규 가입 시 "초대코드(선택)"란에 입력해야 적용돼요.{'\n'}* 이미 가입한 계정에는 소급 적용되지 않아요.</Text>
      </View>
    </View>
  );
}

const s = StyleSheet.create({
  container: { flex: 1, backgroundColor: BG },
  body: { flex: 1, alignItems: 'center', padding: 24, paddingTop: 32 },
  iconWrap: { width: 72, height: 72, borderRadius: 36, backgroundColor: SURFACE2, alignItems: 'center', justifyContent: 'center', marginBottom: 16 },
  title: { color: TEXT, fontSize: 18, fontWeight: '800', textAlign: 'center', lineHeight: 26, marginBottom: 24 },
  rewardRow: { flexDirection: 'row', gap: 10, width: '100%', marginBottom: 28 },
  rewardCard: { flex: 1, backgroundColor: SURFACE, borderWidth: 1, borderColor: BORDER, borderRadius: 14, padding: 16, alignItems: 'center', gap: 6 },
  rewardLabel: { color: TEXT_SEC, fontSize: 12, fontWeight: '600' },
  rewardValue: { color: GOLD, fontSize: 20, fontWeight: '900' },
  codeLabel: { color: TEXT_SEC, fontSize: 12, fontWeight: '700', alignSelf: 'flex-start', marginBottom: 6 },
  codeInput: { width: '100%', backgroundColor: SURFACE2, borderWidth: 1, borderColor: BORDER, borderRadius: 12, paddingHorizontal: 14, paddingVertical: 12, color: TEXT, fontSize: 13, fontWeight: '600' },
  codeHint: { color: TEXT_MUTED, fontSize: 11, marginTop: 8, alignSelf: 'flex-start' },
  note: { color: TEXT_MUTED, fontSize: 11, textAlign: 'center', lineHeight: 17, marginTop: 28 },
});
